const alphabetPersian =
  'الف ب پ ت ث ج چ ح خ د ذ ر ز ژس ش ص ض ط ظ ع غ ف ق ک گ ل م ن و ه ی';

export const alphba = alphabetPersian.split(' ');
